export function getTagsOrNiches(list) {
  return (
    list
      ?.map(item => {
        return {
          id: item.tag,
          name: item.tag,
          tags: item.tagList,
          performance: {
            ...item?.tagPerformance?.sparkline,
            totalPosts: item?.tagPerformance?.sparkline?.total,
          },
          type: 'tag',
        }
      })
      .filter(item => item.name !== null && item.name !== undefined) ?? []
  )
}
